import { Button, Stack, Typography } from '@mui/material';
import { SummaryBox } from '@/packages/subsidy/pages/refund-request/components/summary-box';
import { useRefundRequestNavigation } from '@/packages/subsidy/pages/refund-request/steps/resource-description/navigation/use-navigation';
import { RefundRequestWizardStepIds } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/step-ids';
import { refundValueDetail } from '@/utils/refund-value-detail';

const stepId = RefundRequestWizardStepIds.Summary;

interface ApprovedProps {
  totalAmount: number;
  policyRefundLimit: string | null;
  handleSubmit: () => void;
  loading?: boolean;
}

export const Approved = ({
  policyRefundLimit,
  totalAmount,
  handleSubmit,
  loading,
}: ApprovedProps) => {
  const { handleBack, values } = useRefundRequestNavigation({ stepId });
  const selectedPolicy = values?.selectedPolicy;
  const { policyText, shouldShowRefundableValue } = refundValueDetail(
    selectedPolicy?.limits
  );
  const totalAmountSummary = {
    label: 'Custo total do item',
    value: totalAmount,
  };
  const refundableValueSummary = {
    label: 'Limite de reembolso',
    value: policyRefundLimit,
    detail: policyText,
  };

  const summaryItems = [
    totalAmountSummary,
    ...(shouldShowRefundableValue ? [refundableValueSummary] : []),
  ];

  return (
    <Stack gap={1}>
      <Typography variant="h3">Reembolso disponível</Typography>
      <Typography>
        Calculado de acordo com as regras de reembolso da sua política. O
        reembolso final depende também do seu saldo disponível.
      </Typography>
      <SummaryBox my={2} sx={{ borderRadius: 1 }} items={summaryItems} />
      <Stack direction="row" justifyContent="flex-end" gap={2}>
        <Button onClick={handleBack}>Voltar</Button>
        <Button onClick={handleSubmit} variant="contained" loading={loading}>
          Enviar para aprovação
        </Button>
      </Stack>
    </Stack>
  );
};
